import { default500, fontSizeBodySM, fontWeightSemibold } from 'lib/mortar';
import styled from 'styled-components';
import { fontFamilyMain } from 'lib/design-system';

export const TextButton = styled.button<StyledButton>`
  cursor: pointer;
  color: ${default500};
  text-align: center;
  font-size: ${fontSizeBodySM};
  font-family: ${fontFamilyMain};
  font-weight: ${fontWeightSemibold};
`;
